import React, {Component} from "react";
import axios from 'axios';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

export default class SignUp extends Component {

  constructor(props) {
    super(props);
    this.state = {
      employer: {
        first_name: undefined,
        last_name: undefined,
        email: undefined,
        phone: undefined,
        password: undefined,
        company: undefined,
        website: undefined,
      },
      errorMsg: undefined,
      saving: false,
      msg: undefined,
      confirm_password: undefined,
    }
  }

  handleChange = (e) => {
    let id = e.target.id;
    if (id === 'confirm_password') {
      this.setState({
        [id]: e.target.value,
        errorMsg: undefined
      });
    } else {
      this.setState({
        employer: {
          ...this.state.employer,
          [id]: e.target.value
        },
        errorMsg: undefined
      });
    }
  }

  handleSectorSelect = (e) => {
    this.setState({
      employer: {
        ...this.state.employer,
        sectors: e
      }
    });
  }

  redirect = () => {
    setTimeout(() => {
      window.location.href = "/kingstonconnect/thankyou/register"
    }, 500)
  }

  signUp = (e) => {
    e.preventDefault();
    this.setState({ saving: true })
    // Check to make sure confirm and password match
    if (this.state.employer.password !== this.state.confirm_password){
      this.setState({ errorMsg: "Passwords do not match.", saving: false})
    } else {
      axios.post('/api/kingstonconnect/addemployers', {
        data: this.state.employer
      })
      .then(res => {
        let result = res.data.success;
        this.setState({ saving: false })
        if (result) {
          this.setState({
            msg: "Please check your email to verify your address."
          })
          this.redirect()

        } else if (res.data.message.code === 11000) {
          this.setState({
            errorMsg: "Email has already been registered."
          })
        } else {
          this.setState({
            errorMsg: "Something unexpected has occured, please try again later."
          })
        }
      });
    }
  }

  render() {
    return(
      <div>
        <div className="form-group">
          <form onSubmit={this.signUp}>
            <div className="form-group col-8 offset-2">
              <div className="row">
                <div className="form-group col-6">
                  <label>First Name</label>
                  <input onChange={this.handleChange} id="first_name" value={this.state.first_name} required className="form-control" />
                </div>
                <div className="form-group col-6">
                  <label>Last Name</label>
                  <input onChange={this.handleChange} id="last_name" value={this.state.last_name} required className="form-control" />
                </div>
              </div>
              <label>Email</label>
              <input onChange={this.handleChange} type="email" id="email" value={this.state.email} className="form-control" />
              <small className="form-text text-muted">Optional</small>
              <br/>
              <label>Phone Number</label>
              <input onChange={this.handleChange} id="phone" value={this.state.phone} className="form-control" />
              <small className="form-text text-muted">Optional</small>
              <br/>
              <label>Password</label>
              <input onChange={this.handleChange} type="password" id="password" value={this.state.password} required className="form-control" />
              <br/>
              <label>Confirm Password</label>
              <input type="password" onChange={this.handleChange} id="confirm_password" required className="form-control" />
              <br/>
              <label>Employer/Organization</label>
              <input onChange={this.handleChange} id="company" value={this.state.company} required className="form-control" />
              <br/>
              {/*
              <label>Address</label>
              <input onChange={this.handleChange} id="address" value={this.state.address} type="text"  className="form-control" />

              <label>Sectors</label>
              <Select
                onChange={this.handleSectorSelect}
                value={this.state.sectors}
                options={sectors.slice(1)}
                isMulti={true}
                id="sectors"
                isSearchable />

                */}
              <label>Website</label>
              <input onChange={this.handleChange} id="website" value={this.state.website} type="text"  className="form-control" />
              <br/>

              {/*
              <h5>HR Contact Info</h5>
              <label>Name</label>
              <input onChange={this.handleChange} id="hr_name" value={this.state.hr_name} required className="form-control" />

              <label>Email</label>
              <input onChange={this.handleChange} id="hr_email" value={this.state.hr_email} type="email" required className="form-control" />

              <label>Phone Number</label>
              <input onChange={this.handleChange} id="hr_phone_number" value={this.state.hr_phone_number} required type="text" className="form-control" />

              */}
            </div>

            {this.state.errorMsg &&
              <div className="alert alert-danger" role="alert">
                <strong>Uh oh!</strong>{' ' + this.state.errorMsg}
              </div>
            }
            {this.state.msg &&
              <div className="alert alert-success" role="alert">
                <strong>Success!</strong>{' ' + this.state.msg}
              </div>
            }
            {!this.state.deleted &&
              <button className="btn btn-primary" style={{"marginBottom": "1%"}}>
                {"Submit "}
                {this.state.saving &&
                  <FontAwesomeIcon spin
                  icon={faSpinner}
                  />
                }
              </button>}
          </form>
        </div>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/components/pages/KingstonConnect/SignUp.js